import { TableColumnInterface } from "@/common/types";
export const cvsColumns: Array<TableColumnInterface> = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    width: 300,
    sorter: true,
    scopedSlots: { customRender: "cvName" },
  },
  {
    title: "Nr. of CVs",
    dataIndex: "cvs_count",
    key: "cvs_count",
    width: 140,
    scopedSlots: { customRender: "cvsCount" },
  },
];
